import React, {ChangeEvent, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import cn from 'classnames';
import {isRequiredValidator} from '../../utils/helpers/validators';

import './styles.scss';

interface IGritxButtonProps {
  name: string;
  placeholder?: string;
  defaultValue?: string | number;
  className?: string;
  selectClassName?: string;
  disabled?: boolean;
  options: { id: string | number; name: string }[]
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLSelectElement>) => void;
  value?: string | number;
  label?: string
  required?: boolean
}

const errorTypes = {
  required: 'required'
};

const errorMessage: { [type: string]: { id: string; defaultMessage: string } } = {
  [errorTypes.required]: {
    id: 'gritx.common.errors.required',
    defaultMessage: 'This field cannot be blank'
  }
};

export const GritxSelect = ({
  name,
  className,
  selectClassName,
  placeholder,
  defaultValue,
  disabled = false,
  options,
  onChange,
  onBlur,
  label,
  required,
  value
}: IGritxButtonProps): JSX.Element => {
  const [errors, setErrors] = useState<string[]>([]);

  function validateValue(val: string, req?: boolean): string[] {
    let err = [] as string[];

    console.log('val === placeholder = ', val === 'placeholder');

    if (req && (!isRequiredValidator(val) || val === 'placeholder')) {
      err = [errorTypes.required];
    }

    if (!req && val.length === 0) {
      err = [];
    }

    return err;
  }

  function handleBlur(e: ChangeEvent<HTMLSelectElement>) {
    setErrors(validateValue(e.target.value, required));
    if (onBlur) {
      onBlur(e);
    }
  }

  function handleChange(e: ChangeEvent<HTMLSelectElement>) {
    if (required && (!isRequiredValidator(e.target.value) || e.target.value === 'placeholder')) {
      return;
    }
    setErrors([]);
    onChange(e);
  }

  return <div className={cn('gritx-select', className)}>
    {label && <span className={'gritx-select__label-text'}>
      {label}
      {required && <span className={'gritx-select__required'}>*</span>}
    </span>}
    <div className={cn('gritx-select__select', selectClassName)}>
      <select
        name={name}
        className='gritx-select__form-component'
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
      >
        {placeholder && <option value={'placeholder'} disabled hidden>{placeholder}</option>}
        {
          options.map(option => {
            return <option key={option.id} value={option.id}>
              {option.name}
            </option>;
          })
        }
      </select>
    </div>
    {
      errors.map((e, i) => <span key={i} className="gritx-select__error">
        {errorMessage[e] && <FormattedMessage {...errorMessage[e]}/>}
      </span>)
    }
  </div>;
};
